import { CheckBoxOptionType } from "@portal/BaseComponents/CheckBox/type";
import { MenuGroup } from "@portal/BaseComponents/Menu/type";
import { getPaymentModeLabel } from "@portal/Components/Portal/PotalTabs/Payment/predicate";
import { PaymentMode } from "@portal/types/entities/payment";
import { PaymentDefaultKeys } from "./type";

const customerFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Customer",
    key: "Customer",
    children: [],
  },
];
const InvoiceFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Invoice",
    key: "Invoice",
    children: [],
  },
];
const PaymentFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Payments",
    key: "Payment",
    children: [],
  },
];

export const paymentFilterGroups = [
  ...PaymentFilterGroups,
  ...customerFilterGroups,
  ...InvoiceFilterGroups,
];

const paymentModes: PaymentMode[] = [
  "ACH",
  "BANK_REMITTANCE",
  "BANK_TRANSFER",
  "CASH",
  "CHECK",
  "CREDIT_CARD",
  "DEBIT_CARD",
  "DIRECT_DEBIT",
  "OFFLINE_PAYMENT",
  "OTHER",
  "PAYPAL",
  "WIRE_TRANSFER",
];

export function getPaymentModeOptions(): CheckBoxOptionType<PaymentMode>[] {
  return paymentModes.map((mode) => {
    return { label: getPaymentModeLabel(mode)?.label, value: mode };
  });
}

export const paymentDefaultKeys: PaymentDefaultKeys[] = [
  "from_date",
  "modes",
  "date_range",
  "to_date",
  "statuses",
];
